import React, { memo, useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { primaryGradient } from 'root/src/client/web/commonStyles'
import LoadingSpinner from 'root/src/client/web/base/LoadingSpinner'
import SecondaryButton from 'root/src/client/web/base/CustomButton/SecondaryButton'
import { faTwitch } from '@fortawesome/free-brands-svg-icons/faTwitch'

const style = {
	btnTwitchContainer: {
		position: 'fixed',
		right: 100,
		top: 150,
		zIndex: 1000,
	},
	btnTwitch: {
		background: primaryGradient,
		padding: 30,
		fontSize: 14,
		border: 'none',
	},
	spinner: {
		'& svg': {
			margin: 'unset',
		},
	},
}

const Button = memo(({ classes, oauthAuthenticate }) => {
	const mainTitle = 'Get Started!'
	const [title, setTitle] = useState(mainTitle)
	const [loading, setLoading] = useState(false)

	return (
		<div
			className={classes.btnTwitchContainer}
			onMouseEnter={() => setTitle('Connect Twitch to Get Started!')}
			onMouseLeave={() => setTitle(mainTitle)}
		>
			<SecondaryButton
				icon={faTwitch}
				className={classes.btnTwitch}
				iconSize="2x"
				title={title}
				onClick={e => oauthAuthenticate('twitch')(e, setLoading)}
			>
				<LoadingSpinner loading={loading} size={26} className={classes.spinner} />
			</SecondaryButton>
		</div>
	)
})

export default withStyles(style, { name: 'MuiGetStartedButton' })(Button)
